





































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































declare var window: any;
import { User } from '@/models/userdata/userdto';
import { vxm } from './../../store.vuex';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Jobseeker from './../Jobseeker.vue';
import Myreferrals from './../Myreferrals.vue';
import Referrals from './../Referrals.vue';
import { JobsStore } from '@/models/jobs/jobs.vuex';
import { Job } from '@/models/jobs/job';
import { BFormFile } from 'bootstrap-vue/es/components';
import { ResumePayload } from '../../models/jobs/resumepayload';
import { JobTokenPayload } from '../../models/jobs/jobTokenPayload';
import SelectOptions from './../SelectOptions.vue';
import { Apply } from '../../models/jobs/jobapply';
import { SupportingInfoPayload } from '../../models/jobs/supportinginfoPayload';
import { ResumeWrapper } from '../../models/jobs/resumeWrapper';
import { GenericLookup } from '../../models/utility/lookup';
import { JobApplication } from '../../models/jobs/jobapplication';
import { ApplyRequestWrapper } from '../../models/jobs/jobapply';
import { UserProfile } from '../../models/userdata/profile';
import { UserSkillsWrapper } from '../../models/skills/userskillwrapper';
import DatePicker from 'vuejs-datepicker';
import {en, de, es, fr} from 'vuejs-datepicker/dist/locale';
import { UserSkill } from '../../models/skills/skills';
import { SkillType } from '../../models/userdata/skilltype';
import { CompanySkill } from '../../models/skills/companyskills';
import { SkillResponse } from '../../models/skills/skillresponse';
import { VerticalSkillRespose } from '../../models/skills/VerticalSkillRespose';
import { UserAttribute } from '../../models/skills/userattribute';
import { SkillDocWrapper } from '../../models/skills/skilldocwrapper';
import { DocumentPayload } from '../../models/skills/documentpayload';
import { UserAttrSkillWrapper } from '../../models/skills/userattrskillwrapper';
import { SkillDocument } from '../../models/skills/skilldocument';
Vue.component('paginate', Paginate);
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import { DocumentResponse } from '../../models/skills/documentresponse';
import { SpinnerPlugin } from 'bootstrap-vue/es/components';
import { Referral } from './../../models/referrals/referral';
import Loader from './../Loader.vue';
import Multiselect from 'vue-multiselect';

import {
  QuestionnaireResponse,
  UserQuestionResponse,
} from '../../models/jobs/questionnaireresponse';
import { UserAttributeWrapper } from '../../models/jobs/userattributewrapper';
import { Questionnaire } from '../../models/jobs/questionnaire';
import { QuestionResponseData,QuestionnaireDetailRequest } from '../../models/jobs/questionnaireresponse';
import Paginate from 'vuejs-paginate';
import router from '@/router';
Vue.component('paginate', Paginate);
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import ResumeDetailsApply from './../ResumeDetailsApply.vue';
import {
  SURVEY_DETAILS_SUCCESS_MESSAGE,
  SURVEY_QUESTION_CODE_TEXT,
  SURVEY_QUESTION_CODE_MULTIPLE_CHOICE,
  SURVEY_QUESTION_CODE_RADIO,
  SURVEY_QUESTION_CODE_DROPDOWN,
  SURVEY_QUESTION_CODE_RATING,
  SURVEY_FEEDBACK_QUESTION_CODE_TEXT,
  RATING_F_QUES_CONDITION_ID_EQUAL,
  RATING_F_QUES_CONDITION_ID_GREATER_THAN,
  RATING_F_QUES_CONDITION_ID_LESS_THAN,
  SURVEY_DETAILS_ERROR_MESSAGE,
  CANDIDATE_PORTAL_SURVEY_TODAY_TEXT,
  SURVEY_DETAILS_DATA_FETCHING_MESSAGE,
} from './../Survey/SurveyConstants';
import { JobActionCodeConstants } from '@/components/QuickApply/JobActionCodeConstants';
import ResumeDetailsAnonApply from './ResumeDetailsAnonApply.vue';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 3000,
});
@Component({
  name: 'NewJobApplyFlow',
  components: {
    Jobseeker,
    Myreferrals,
    Referrals,
    SelectOptions,
    ResumeDetailsApply,
    ResumeDetailsAnonApply,
    Multiselect,
    DatePicker
  },
})
export default class NewJobApplyFlow extends Vue {
  private resumePayload: ResumePayload = new ResumePayload();
  private showDetail: boolean = false;
  private supportingInfos: any[] = [];
  private questionnaire: Questionnaire = vxm.jobs.Questionnaire;
  private showDefault: boolean = false;
  private resumeListing: ResumeWrapper = new ResumeWrapper();
  private genericLookup: GenericLookup[] = [];
  private selectedOption: GenericLookup = new GenericLookup();
  private selectedResume: string = '';
  private defaultSelected: boolean = false;
  private applyPayload: JobApplication = new JobApplication();
  private currentPage: number = 1;
  private recsPerPage: number = 5;
  private uploadedResumeGUID: string = '';
  private dropdownSelectedValue: any[]=[]
  private questionnaireResponse: QuestionnaireResponse[] = [];
  $wlToastr: any;
  private isResponseLoaded: boolean = false;
  private supportingInfoPayload: SupportingInfoPayload = new SupportingInfoPayload();
  private questionnaireData: any[] = [];
  private branchedQuestions: any[] = [];
  public userId : number =0;
  public backupquestionResponses : QuestionResponseData[] = [];
  public questionListResponses : any[] = [];
  private resumeUploadRequired: boolean = false;
  private degreeUploadRequired: boolean = false;
  private questionnaireRequired: boolean = false;
  private enableResumeUploadBtn: boolean = false;
  private isResumeActionComplete: boolean = false;
  private isDegreeActionComplete: boolean = false;
  public hasNextSetOfQuestion : boolean = false;
  public enableNextDisableContinue : boolean = false;
  private hasPreviousSetOfQuestion : boolean =  false;
  private questionnaireActionComplete: boolean = false;
  private jobPostingId = 0;
  private job: Job = new Job();
  private isJobApplied: boolean = false;
  private supportingDocuments: any[] = [];
  private nextpage = localStorage.nextpage;
  private isResumeContinueBtn = false;
  private isSupportingContinueBtn = false;
  private isQuestionnaireContinueBtn = false;
  private jobToken: any;
  private supportedFileSize = 0;
  private alphaRegex: RegExp = new RegExp(
    /^[a-zA-Z ]+$/,
  );
  private alphaNumericRegex: RegExp = new RegExp(
  /^[a-zA-Z0-9 /]*$/,);
  // private answeredQuestions: any[] = [];
  // private requiredQuestionCount = 0;
  $moment: any;
  @Prop() jobApplicationSteps;
  @Prop() hasBranchedQuestionere;
  @Prop() questionTemplateId;
  @Prop() userDetails;
private errors = {
email: '',
password: '',
confirmPassword: '',
firstName: '',
lastName: '',
phone: '',
};

  get getLanguage() {
    const lang = vxm.users.getUserLang || 'en';
    return {en, de, es, fr}[lang];
  }

  get allowedResumeFormat() {
    return vxm.configs.getGlobalConfigValue('ALLOWED_RESUME_FORMATS');
  }

  get showResumeUpload() {
    return (
      this.job.resumeUploadRequired ===
        JobActionCodeConstants.RESUME_UPLOAD_MANDATORY ||
        this.job.resumeUploadRequired ===
        "1"||
      this.job.resumeUploadRequired ===
        JobActionCodeConstants.RESUME_UPLOAD_OPTIONAL
    );
  }

  processResuemUpload2(resumeGUID) {
    //this.processResuemUpload(this.jobToken);
    this.selectedOption.id = resumeGUID;
    this.processResumeResponse(vxm.jobs.resumeListing);
  }

  processResuemUpload(jobToken) {
    this.$modal.show('survey-spinner');
    vxm.jobs.getDefaultResume(vxm.users.getToken).then((resumeResp) => {
      this.$modal.hide('survey-spinner');
      this.processResumeResponse(resumeResp);
    });
  }

  goToReferral(job: Job) {
    let jid = job.jobPostingId + '';
    vxm.referrals.setJobID(parseInt(jid, 10));
    vxm.referrals.setRefferedJob(job.jobPostingName);
    if (vxm.users.isLoggedIn === false) {
      this.$router.push({ name: 'JobShare', params: { JobID: jid } });
    } else {
      const referral = new Referral();
      referral.jobPostingId = parseInt(jid, 10);
      referral.userFullName =
        vxm.users.myUserProfile.firstName +
        ' ' +
        vxm.users.myUserProfile.lastName;
      referral.email = vxm.users.myUserProfile.email;
      // referral.referralCode = this.$route.params.referralCode;
      referral.companyCode = vxm.jobs.BrandingInfo.companycode;
      referral.referredJobLocation = job.facility.name;
      console.log(referral);
      vxm.referrals.setReferral(referral);
      vxm.referrals.jobShareReferral(referral);
    }
  }

  mounted() {
    this.errors = this.errors;
    this.job = vxm.jobs.AnonymousJobByID;
    this.supportedFileSize = vxm.utility.fileUploadMaxSize;
    this.jobApplicationSteps = this.readJobApplicationSteps();
    if (
      !this.isResumeActionComplete &&
      (this.job.resumeUploadRequired ===
        JobActionCodeConstants.RESUME_UPLOAD_OPTIONAL ||
        this.job.resumeUploadRequired ===
          JobActionCodeConstants.RESUME_UPLOAD_NOT_REQUIRED)
    ) {
      this.isResumeActionComplete = true;
    }

    if (this.jobApplicationSteps) {
      const questionnaire = this.jobApplicationSteps.filter(
        (workflowStepAction) => '02' == workflowStepAction.actionCode,
      );
      if (questionnaire && questionnaire.length > 0) {
        this.questionnaireData = this.processQuestionnaireResponse(
          questionnaire[0],
        );
        console.log("this.questionnaireData",this.questionnaireData);
        this.enableQuestionActionFlag(null);
      }
    }
    var uploadBlkElements = document.getElementsByClassName('upload-blk');
    var counter = 0;

    Array.from(uploadBlkElements).forEach(function(element: any) {
      element.style.counterReset = 'myIndex ' + counter;
      counter++;
    });
    if(this.hasBranchedQuestionere){
       this.getAnonBranchedQuestions();
    }
  }

  get companyCode() {
    return vxm.jobs.CompanyInfo.companyId;
  }

  async getAnonBranchedQuestions(navigation?){
  let questionnaireDetailRequset : QuestionnaireDetailRequest = new QuestionnaireDetailRequest();
  questionnaireDetailRequset.companyCode = this.companyCode;
  questionnaireDetailRequset.questionnaireInfo.jobPostingId = this.$route.params.JobID;
  questionnaireDetailRequset.navigation = "";
  questionnaireDetailRequset.currentQuestionId = '';
  questionnaireDetailRequset.questionnaireInfo.questionResponseData = [];
  questionnaireDetailRequset.questionnaireInfo.referralCode= vxm.referrals.globalRefCode
        ? vxm.referrals.globalRefCode
        : '';
  questionnaireDetailRequset.questionnaireInfo.userId = this.userId;
  questionnaireDetailRequset.questionnaireInfo.questionTemplateId = this.questionTemplateId;
  if(navigation === 'previous') {
    questionnaireDetailRequset.navigation = navigation;
    questionnaireDetailRequset.currentQuestionId= this.branchedQuestions[0].questionID;
    questionnaireDetailRequset.questionnaireInfo.questionResponseData = this.prepareBranchedQuestionnaireRequestPayload();
  }
  if(navigation === 'next') {
    questionnaireDetailRequset.navigation = navigation;
    questionnaireDetailRequset.currentQuestionId= this.branchedQuestions[this.branchedQuestions.length -1].questionID;;
    questionnaireDetailRequset.questionnaireInfo.questionResponseData = this.prepareBranchedQuestionnaireRequestPayload();
    // this.questionListResponses.push(this.backupquestionResponses);
   }
  this.$modal.show('survey-spinner');
  let respPromise1 = vxm.jobs.getAnonJobApplicationBranchedQuestions(questionnaireDetailRequset);
   Promise.all([respPromise1]).then(
      (response) => {
        console.log("response",response);
        if (response) {
          console.log(" calling this.processBranchedQuestionResponse",response);
           this.$emit('has-next-question',response[0].hasNextQuestion);
          if(response && response[0].questions && response[0].questions.length === 0 && 
          response[0].hasNextQuestion === false &&  navigation === 'next'
          ){
            this.$wlToastr(
            'error',
            "You\'ve reached the end of the questionnaire. Please tick the terms of service and privacy policy details check box and then click on the 'Apply' button to proceed",
            'Job Application',
             );
             this.questionnaireActionComplete = true;
             this.hasNextSetOfQuestion = false;
             this.enableNextDisableContinue = true;
             return;
          }
          this.$modal.hide('survey-spinner');
          
          this.dropdownSelectedValue=[];
          this.branchedQuestions = JSON.parse(JSON.stringify(this.processBranchedQuestionResponse(response)))
        }
      },
      (err) => {
        this.$modal.hide('survey-spinner');
        this.$wlToastr(
          'error',
          SURVEY_DETAILS_ERROR_MESSAGE,
          'Candidate Survey',
        );
      },
    );
  }

  readJobApplicationSteps(): any[] {
    const jobApplicationStepsObj = vxm.jobs.jobApplicationWorkflowSteps;
    if (jobApplicationStepsObj && jobApplicationStepsObj.workflowStepActions) {
      return jobApplicationStepsObj.workflowStepActions;
    } else {
      return [];
    }
  }

  processResumeResponse(response) {
    this.resumeListing = response;
    let defaultResume = this.resumeListing.resumes.filter(
      (item) => item.defaultResume,
    );
    if (defaultResume && defaultResume.length > 0) {
      this.selectedOption.name = defaultResume[0].name;
      this.resumePayload.resumelink = defaultResume[0].fileGUID;
      this.resumePayload.resume.resumename = defaultResume[0].name;
      this.uploadedResumeGUID = defaultResume[0].fileGUID;
      this.isResumeActionComplete = true;
    }
    if (
      !this.isResumeActionComplete &&
      (this.job.resumeUploadRequired ===
        JobActionCodeConstants.RESUME_UPLOAD_OPTIONAL ||
        this.job.resumeUploadRequired ===
          JobActionCodeConstants.RESUME_UPLOAD_NOT_REQUIRED)
    ) {
      this.isResumeActionComplete = true;
    }
    this.isResumeContinueBtn = true;
    this.isSupportingContinueBtn = false;
    this.isQuestionnaireContinueBtn = false;
    this.resumeUploadRequired = true;
  }

  
  processBranchedQuestionResponse(response){
    this.hasNextSetOfQuestion = response[0].hasNextQuestion;
    this.hasPreviousSetOfQuestion = response[0].hasPreviousQuestion;
    this.branchedQuestions = this.processQuestionnaireResponse(response[0]);
    return this.branchedQuestions;
  }

  
  processQuestionnaireResponse(response) {
    let isQuestionnaireActionComplete = true;
    if(response && response.questions && response.questions.length > 0) {
      let questionIndex = -1;
      let questionRequiredCount = 0;
      let answeredQuestionCount = 0;
      response.questions.forEach((question) => {
        questionIndex = questionIndex + 1;
        if(question.questionRequired){
          questionRequiredCount = questionRequiredCount+1;
        }
        if(!this.hasBranchedQuestionere){
           this.dropdownSelectedValue.push([]);
        }
        isQuestionnaireActionComplete = false;
        this.branchedQuestionnierComplete = false;
          if(!question.questionRequired){
            this.branchedQuestionnierComplete = true;
          }
        if (question.questionRequired && question.userQuestionResponse) {
          if (
            (question.userQuestionResponse.userAnswerList &&
              question.userQuestionResponse.userAnswerList.length > 0) ||
            question.userQuestionResponse.questionTextResponse
          ) {
           answeredQuestionCount = answeredQuestionCount+1;
           isQuestionnaireActionComplete = true;
           this.branchedQuestionnierComplete = true;
        }
        }
        if (
          question.userQuestionResponse &&
          question.userQuestionResponse.userAnswerList &&
          (question.questionType === SURVEY_QUESTION_CODE_RADIO ||
            question.questionType === SURVEY_QUESTION_CODE_RATING || 
            question.questionType === SURVEY_QUESTION_CODE_DROPDOWN)
        ) {
          question.userQuestionResponse.userAnswerList =
            question.userQuestionResponse.userAnswerList[0];

            if (
          question.questionType === SURVEY_QUESTION_CODE_RATING &&
          question.userQuestionResponse &&
          question.userQuestionResponse.userAnswerList
        ) {
          let answerId = question.userQuestionResponse.userAnswerList;
          let ind = question.answerList.findIndex(
            (answer) => answer.answerMasterID === answerId,
          );

          question.answerIndex = ind;
        }
        }
        if (!question.userQuestionResponse) {
          question.userQuestionResponse = {
            userAnswerList: [],
            questionTextResponse: '',
          };
        }
        if(question.questionType == '01' && question.userQuestionResponse.userAnswerList.length>0){
          let multiList : any[]=[];
          for(var i=0; i<question.userQuestionResponse.userAnswerList.length;i++){
          for(var j=0; j<question.answerList.length;j++ ){
            if(question.userQuestionResponse.userAnswerList[i] == question.answerList[j].answerMasterID ){
              multiList.push(question.answerList[j]);
              console.log("this.dropdown",this.dropdownSelectedValue);
            }
          }      
          }
          this.dropdownSelectedValue[questionIndex] = multiList;
          console.log("this.dropdown is of multiple choice",this.dropdownSelectedValue);
        }
        if((question.questionType == '03' || question.questionType == '12' ) && question.userQuestionResponse.userAnswerList){
          for(var j=0; j<question.answerList.length;j++ ){
            if(question.userQuestionResponse.userAnswerList == question.answerList[j].answerMasterID ){
              this.dropdownSelectedValue[questionIndex] = question.answerList[j];
            }
          } 
        }
      });
      if(answeredQuestionCount !== questionRequiredCount){
           isQuestionnaireActionComplete = false;
           this.branchedQuestionnierComplete = false;
      }
      this.questionnaireActionComplete = isQuestionnaireActionComplete;
      if(this.hasBranchedQuestionere){
       this.$emit('branch-question-complete',this.branchedQuestionnierComplete);
      }
      // this.branchedQuestionnierComplete = isQuestionnaireActionComplete
      return response.questions;
    }

    this.questionnaireRequired = false;
   this.questionnaireActionComplete = isQuestionnaireActionComplete;
    return [];
  }

  processSupportingInfosResponse(response) {
    const userAttributeWrapper = response;
    const profileData = vxm.users.myUserProfile;
    let documentResponseMap = new Map();
    let skillTypeListMap = new Map();
    const userAttributeList = profileData.userAttributeSkills.forEach(
      (element) => {
        documentResponseMap.set(
          element.userAttribute.userAttributeID,
          element.documentResponse,
        );
        skillTypeListMap.set(
          element.userAttribute.userAttributeID,
          element.skillTypeList,
        );
      },
    );
    this.isDegreeActionComplete = true;
    let userAttributeWithUploadedDoc: any[] = [];
    this.supportingDocuments = userAttributeWrapper.userAttributeList;
    userAttributeWrapper.userAttributeList.forEach((element) => {
      if (documentResponseMap.has(element.userAttributeID)) {
        userAttributeWithUploadedDoc.push({
          userAttribute: element,
          documentResponse: documentResponseMap.get(element.userAttributeID)
            ? documentResponseMap.get(element.userAttributeID)
            : element.userAttributeDocument,
          skillTypeList: skillTypeListMap.get(element.userAttributeID),
        });
      } else if (element.userAttributeDocument) {
        userAttributeWithUploadedDoc.push({
          userAttribute: element,
          documentResponse: element.userAttributeDocument,
        });
      } else {
        this.isDegreeActionComplete = false;
        userAttributeWithUploadedDoc.push({
          userAttribute: element,
          documentResponse: null,
        });
      }
    });
    this.supportingInfos = userAttributeWithUploadedDoc;

    let mandatoryDoc = userAttributeWithUploadedDoc.filter(
      (doc) => doc.userAttribute.attributeRequired && !doc.documentResponse,
    );
    this.isDegreeActionComplete =
      mandatoryDoc && mandatoryDoc.length > 0 ? false : true;
    this.degreeUploadRequired =
      this.supportingInfos && this.supportingInfos.length > 0 ? true : false;
    this.isResumeContinueBtn = false;
    this.isSupportingContinueBtn = true;
    this.isQuestionnaireContinueBtn = false;
  }

  goToUpload(jid: string) {
    const vm = this;
    if (!vxm.users.getToken) {
      this.setNavigation('JobDetails:' + jid);
      this.$router.push({ name: 'Login' });
    } else {
      vxm.jobs.setJobID(parseInt(jid, 10));
      const jobApply = new ApplyRequestWrapper();
      jobApply.accessToken = vxm.users.getToken;
      jobApply.applyRequest.jobPostingId = parseInt(jid, 10);
      // jobApply.applyRequest.referralCode = this.$route.params.referralCode;
      jobApply.applyRequest.companyCode = this.$store.state.jobs.companyCode;

      const respPromise: any = vxm.jobs.getNexSteps(jobApply);
      this.$modal.show('survey-spinner');
      Promise.all([respPromise]).then((resp) => {
        this.$modal.hide('survey-spinner');
        this.processJobApplicationResponse(resp, jid);
      });
    }
  }

  showMessage(value) {
    const jobId = this.$route.params.JobID;
    if (value) {
      if (!value.success) {
        if (value.errorCode === '1002') {
          const errorMessageText = value.errorMessage;
          this.$wlToastr(
            'error',
            errorMessageText,
            this.$t('MyJobListing_JobApplication'),
          );
        }
      } else {
        if (value.nextPage === 'success') {
          const successMessage = this.$t('jobs.successfully.applied');
          this.$wlToastr(
            'success',
            successMessage,
            this.$t('MyJobListing_JobApplication'),
          );
          vxm.jobs.setAppliedJob(jobId);
          this.$router.push({
            name: 'JobApplicationSuccess',
            params: { jobId },
          });
        }
      }
    }
  }

  updateSelectedValues(question, value) {
    console.log(value,"option value",Array.isArray(value) ,"Array.isArray(value)");
    if (Array.isArray(value)) {
      question.userQuestionResponse.userAnswerList = value.map(
        (option) => option.answerMasterID,
      );
      console.log("updTESELECTEDif condtion",question.userQuestionResponse.userAnswerList);
    } else {
      let userAnswerList = question.userQuestionResponse.userAnswerList;
      console.log("userAnswerlist",userAnswerList);
      if ( question.questionType === '01' &&
       (question.userQuestionResponse.userAnswerList.length == 0 ||
        (value &&
          !(userAnswerList.includes(
            value.answerMasterID,
          ))))
      ) {
        question.userQuestionResponse.userAnswerList =
          value && value.answerMasterID;
      }else if((question.questionType === '03' || question.questionType === '12')&&
       (question.userQuestionResponse.userAnswerList.length == 0 ||
        (value && userAnswerList !== value))) {
          question.userQuestionResponse.userAnswerList =   value && value.answerMasterID;
      }else {
        question.userQuestionResponse.userAnswerList = [];
      }
    }
    if(this.enableNextDisableContinue){
     this.hasNextSetOfQuestion = true;
      this.$emit('has-next-question',true);
    }
    this.enableNextDisableContinue=false;
    if(this.hasBranchedQuestionere){
       this.enableBranchedQuestionActionFlag(question);
    }else{
      this.enableQuestionActionFlag(question);
    }
  }

  processJobApplicationResponse(apply, jid) {
    if (apply.nextPage === 'otpauthentication') {
      this.$router.push({ name: 'Verification' });
    }
    // error code 1001 resume
    if (
      apply.errorCode === '1001' ||
      apply.nextPage === 'questionnaire' ||
      apply.nextPage === 'supportinginfo'
    ) {
      localStorage.nextpage =
        apply.errorCode === '1001' ? 'resume' : apply.nextPage;
      this.nextpage = localStorage.nextpage;
      if (this.nextpage && this.nextpage === 'resume') {
        this.isResumeContinueBtn = true;
        this.isSupportingContinueBtn = false;
        this.isQuestionnaireContinueBtn = false;
      } else if (this.nextpage && this.nextpage === 'supportinginfo') {
        this.isResumeContinueBtn = false;
        this.isSupportingContinueBtn = true;
        this.isQuestionnaireContinueBtn = false;
      } else if (this.nextpage && this.nextpage === 'questionnaire') {
        this.isResumeContinueBtn = false;
        this.isSupportingContinueBtn = false;
        this.isQuestionnaireContinueBtn = true;
      }
      return;
    }

    if (apply.errorCode === '1002') {
      this.showMessage(apply);
      return;
    }

    if (apply.nextPage === 'success') {
      this.showMessage(apply);
      return;
    }
    this.showMessage(apply);
  }

  getRatingStickWidth(size) {
    return { width: `calc(100% / ${size})` };
  }

  setNavigation(path: string) {
    this.$cookies.set('NavigateTo_ID', path, 600);
  }

  isUserAttrbiuteUploaded(val: DocumentResponse): boolean {
    if (val) {
      return true;
    } else {
      return false;
    }
  }

  textValidate(event, question) {
    event = event ? event : window.event;
    if(question.userQuestionResponse.questionTextResponse.length > 254 ||
      (event.clipboardData && event.clipboardData.getData('text').length > 254)){
      event.preventDefault();
    }

    if(question.validation && question.validation.typeInfo && question.validation.typeInfo.length){
       question.minLength = question.validation.typeInfo.length.min || question.minLength ;
       question.maxLength = question.validation.typeInfo.length.max || question.maxLength;
    }

    if((question.validation && question.validation.type) || question.answerTypeValue){
      const val = event.key || event.clipboardData && event.clipboardData.getData('text');
      switch((question.validation && question.validation.type) || question.answerTypeValue){
        case 'NUMERIC':
        case '01':
          if(isNaN(Number(val))){
            event.preventDefault();
          }
          break;
        case 'ALPHA':
        case '02':
          if(!this.alphaRegex.test(val)){
            event.preventDefault();
          }
          break;
        case 'ALPHANUMERIC':
        case '03':
          if(!this.alphaNumericRegex.test(val)){
            event.preventDefault();
          }
          break;
        default:
          break;
      }
    }
    return true;
  }

  onInput(question) {
    if (this.$refs['question_span2' + question.questionID]) {
      this.$refs['question_span2' + question.questionID][0].textContent =
        '(' +
        question.userQuestionResponse.questionTextResponse.length +
        '/' +
        question.maxLength +
        ')';
    }

    if (
      question.status &&
      question.status === '0' &&
      question.userQuestionResponse.questionTextResponse &&
      question.userQuestionResponse.questionTextResponse.length > 1
    ) {
      question.status = '1';
    } else if (
      question.status &&
      question.status === '1' &&
      question.userQuestionResponse.questionTextResponse &&
      question.userQuestionResponse.questionTextResponse.length === 0
    ) {
      question.status = '0';
    }
    if(this.enableNextDisableContinue){
      this.hasNextSetOfQuestion = true;
      this.$emit('has-next-question',true);
    }
    this.enableNextDisableContinue=false;
    if(this.hasBranchedQuestionere){
       this.enableBranchedQuestionActionFlag(question);
    }else{
      this.enableQuestionActionFlag(question);
    }
  }

  enableBranchedQuestionActionFlag(question) {
    let data = this.branchedQuestions.filter((item) => {
      let questionAnswered = this.isQuestionAnswered(item);

      return item.questionRequired && !questionAnswered;
    });
    let questionnaireActionComplete_ = data && data.length > 0 ? false : true;
    let completed = false;
    if (questionnaireActionComplete_) {
        completed = true;
    }
    this.questionnaireActionComplete = questionnaireActionComplete_;
    // this.$emit('branch-question-complete',this.questionnaireActionComplete);
    const jobId = this.$route.params.JobID;
    const questionnaireResponse = new QuestionnaireResponse();
    questionnaireResponse.userId = vxm.users.myUserProfile.userId + '';
    questionnaireResponse.referralCode = vxm.referrals.globalRefCode
      ? vxm.referrals.globalRefCode
      : '';
    questionnaireResponse.jobPostingId = jobId;
    console.log(
      'questionnaireActionComplete - ' + this.questionnaireActionComplete,
    );
    questionnaireResponse.questionResponseData = this.prepareBranchedQuestionnaireRequestPayload();
    console.log("questionnaireResponse.questionResponseData  before sending apply",questionnaireResponse.questionResponseData);
    if(!this.hasNextSetOfQuestion){  
    this.$emit('job-application-step-submission', {
      stepName: 'QUESTIONNARE',
      data: questionnaireResponse,
      completed: completed,
    });
     }
     if(this.hasBranchedQuestionere){
       this.$emit('branch-question-complete',this.questionnaireActionComplete);
      }
    this.branchedQuestionnierComplete = completed;
  }

  enableQuestionActionFlag(question) {
    let data = this.questionnaireData.filter((item) => {
      let questionAnswered = this.isQuestionAnswered(item);
       return item.questionRequired && !questionAnswered;
    });
    let questionnaireActionComplete_ = data && data.length > 0 ? false : true;
    let completed = false;
    if (questionnaireActionComplete_) {
       completed = true;
    }
    this.questionnaireActionComplete = questionnaireActionComplete_;
    const jobId = this.$route.params.JobID;
    const questionnaireResponse = new QuestionnaireResponse();
    questionnaireResponse.userId = vxm.users.myUserProfile.userId + '';
    questionnaireResponse.referralCode = vxm.referrals.globalRefCode
      ? vxm.referrals.globalRefCode
      : '';
    questionnaireResponse.jobPostingId = jobId;
    questionnaireResponse.questionTemplateId = this.questionTemplateId;
    console.log(
      'questionnaireActionComplete - ' + this.questionnaireActionComplete,
    );
    questionnaireResponse.questionResponseData = this.prepareQuestionnaireRequestPayload();
    this.$emit('job-application-step-submission', {
      stepName: 'QUESTIONNARE',
      data: questionnaireResponse,
      completed: completed,
    });
  }

  isQuestionAnswered(question) {
    if (
      !(
        question.userQuestionResponse &&
        (question.userQuestionResponse.questionTextResponse ||
          (Array.isArray(question.userQuestionResponse.userAnswerList)
            ? question.userQuestionResponse.userAnswerList.length > 0
            : question.userQuestionResponse.userAnswerList))
      )
    ) {
      return false;
    } else {
      return true;
    }
  }

  initHightLightRatingCircle(answerIndex, index) {
    if (index <= answerIndex) {
      return { 'background-color': '#3D91F2' };
    } else {
      return { 'background-color': 'transparent' };
    }
  }

  highlightLeftRating(question, index, answerMasterID) {
    let arr: any = this.$refs['rating_' + question.questionID];
    let size = arr.length;
    for (let i = 0; i < size; i++) {
      arr[i].style['background-color'] = 'transparent';
    }
    arr[index].style['background-color'] = '#3D91F2';
    if (question.userQuestionResponse && question.userQuestionResponse) {
      question.userQuestionResponse.userAnswerList = answerMasterID;
    }
    if(this.enableNextDisableContinue){
      this.hasNextSetOfQuestion = true;
      this.$emit('has-next-question',true);
    }
    this.enableNextDisableContinue=false;
    if(this.hasBranchedQuestionere){
       this.enableBranchedQuestionActionFlag(question);
    }else{
      this.enableQuestionActionFlag(question);
    }
  }

  // @Watch('resumeListing')
  // resumeListingUpdated(newList, oldList) {
  //   this.$emit('disable-next-button', newList.resumes.length === 0);
  // }

  // get questionnaireActionCompleteStatus() {
  //   return this.questionnaireActionComplete;
  // }

  prepareQuestionnaireRequestPayload(): any {
    let questionResponseData: QuestionResponseData[] = [];
    this.questionnaireData.forEach((question) => {
      let obj = {
        questionID: question.questionID,
        userQuestionResponse: question.userQuestionResponse,
      };
      if (
        (question.questionType === SURVEY_QUESTION_CODE_RATING ||
          question.questionType === SURVEY_QUESTION_CODE_RADIO ||
          question.questionType === SURVEY_QUESTION_CODE_DROPDOWN ) &&
        !Array.isArray(obj.userQuestionResponse.userAnswerList)
      ) {
        obj.userQuestionResponse.userAnswerList = [
          obj.userQuestionResponse.userAnswerList,
        ];
      }

      if (question.status && question.status === '0') {
        obj.userQuestionResponse.questionTextResponse = null;
      }
      questionResponseData.push(obj);
    });
    return questionResponseData;
  }


  prepareBranchedQuestionnaireRequestPayload(): any {
    let questionResponseData: QuestionResponseData[] = [];
    this.branchedQuestions.forEach((question) => {
      let obj = {
        questionID: question.questionID,
        userQuestionResponse: question.userQuestionResponse,
      };
      if (
        (question.questionType === SURVEY_QUESTION_CODE_RATING ||
          question.questionType === SURVEY_QUESTION_CODE_RADIO ||
          question.questionType === SURVEY_QUESTION_CODE_DROPDOWN ||
        question.questionType === SURVEY_QUESTION_CODE_MULTIPLE_CHOICE) &&
        !Array.isArray(obj.userQuestionResponse.userAnswerList)
      ) {
        obj.userQuestionResponse.userAnswerList = [
          obj.userQuestionResponse.userAnswerList,
        ];
      }
      if (question.status && question.status === '0') {
        obj.userQuestionResponse.questionTextResponse = null;
      }  
      questionResponseData.push(obj);
      // this.backupquestionResponses.push(obj);
      // this.backupquestionResponses = this.backupquestionResponses.filter((question,index)  => this.backupquestionResponses.findLastIndex(obj => obj.questionID == question.questionID) == index)

});
// console.log("this.backupquestionResponses",this.backupquestionResponses);
//  return new Set(this.backupquestionResponses.reverse());
    return questionResponseData;
}

  
async previewDocument(docGUID) {
  try {
    const authToken = vxm.users.getToken;
    const url = '/wl-profile-svc/api/v2/user-profile/view/resume/' + docGUID;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${authToken}`, 
      },
    });
    
    if (!response.ok) {
      throw new Error('Failed to preview document');
    }
    
    // Open the document in a new tab
    window.open(response.url, '_blank');
  } catch (error) {
    console.error('Error previewing document:', error);
  }
}

  get ApplicationResponse(): Apply {
    return vxm.jobs.ApplicationResponse;
  }

  select(idx: any) {
    this.selectedOption = this.genericLookup[idx];
    this.selectProfileResume(this.selectedOption.name);
  }

  selectProfileResume(name: string) {
    this.selectedResume = name;
  }

  async selectFromDropbox() {
    const vm = this;
    vxm.users
      .uploadDropboxResume()
      .then(async (status) => {
        console.log('STATUS:', status);
        if (status === 'success') {
          vm.$wlToastr(
            'success',
            vm.$t('SkillsDetails_SuccessfullyUploaded'),
            vm.$t('ResumeDetails_UploadResume'),
          );
          const listPromise = await vxm.jobs.getResumeListing(
            vxm.users.getToken,
          );
          vm.resumeListing = vxm.jobs.resumeListing;
        } else {
          vm.$wlToastr(
            'info',
            vm.$t('SkillsDetails_CancelUpload'),
            vm.$t('ResumeDetails_UploadResume'),
          );
        }
      })
      .catch((err) => {
        vm.$wlToastr(
          'error',
          vm.$t('ResumeDetails_UploadResumeError'),
          vm.$t('ResumeDetails_UploadResume'),
        );
      });
  }

  applyJob() {
    if (localStorage.nextpage && localStorage.nextpage === 'questionnaire') {
      this.saveQuestionnaireData();
    } else if (
      localStorage.nextpage &&
      localStorage.nextpage === 'supportinginfo'
    ) {
      this.saveSupportingInfo();
    } else if (localStorage.nextpage && localStorage.nextpage === 'resume') {
      this.chooseResume();
    } else {
      this.goToUpload(this.$route.params.JobID);
    }
  }

  chooseResume() {
    const vm = this;
    vm.applyPayload.jobPostingId = parseInt(vm.$route.params.JobID, 10);
    vm.applyPayload.companyCode = vxm.jobs.BrandingInfo.companycode;
    if (vm.selectedOption.id) {
      vm.applyPayload.resumeGUID = vm.selectedOption.id;
    } else {
      vm.applyPayload.resumeGUID = vm.uploadedResumeGUID;
    }

    vm.applyPayload.resumeCode = this.job.resumeUploadRequired;
    const respPromise: any = vxm.jobs.applyWithProfilResume(vm.applyPayload);

    this.$modal.show('survey-spinner');
    Promise.all([respPromise]).then((values) => {
      this.$modal.hide('survey-spinner');
      if (values[0]) {
        this.processJobApplicationResponse(
          values[0],
          this.supportingInfoPayload.jobID,
        );
      }
    });
  }

  toggleProfileResume() {
    if (this.defaultSelected) {
      this.selectProfileResume(this.setDefault);
    } else {
      this.selectProfileResume('');
    }
  }

  getDistance(job: Job) {
    if (job.distance > 0.1) {
      return job.distance.toFixed(1);
    } else {
      return '< 0.1';
    }
  }

  get canShowLicenceInfo() {
    return vxm.configs.getGlobalConfigValue('SKILL_DOCUMENT_LICENCE_INFO');
  }

  get isLoggedIn(): boolean {
    return vxm.users.isLoggedIn;
  }

  get jobDetail(): Job[] {
    const jobList: Job[] = [];
    jobList.push(vxm.jobs.AnonymousJobByID);
    return jobList;
  }

  get setDefault(): string {
    const idx = this.resumeListing.resumes.findIndex(
      (r) => r.defaultResume === true,
    );
    if (idx >= 0 && this.selectedOption.name === '') {
      return this.resumeListing.resumes[idx].name;
    } else {
      return '';
    }
  }

  saveSupportingInfo() {
    this.supportingInfoPayload.token = vxm.users.getToken;
    this.supportingInfoPayload.jobID = parseInt(this.$route.params.JobID, 10);
    this.supportingInfoPayload.userId = vxm.users.myUserProfile.userId;
    this.supportingInfoPayload.referralCode = vxm.referrals.globalRefCode
      ? vxm.referrals.globalRefCode
      : '';
    this.supportingInfoPayload.supportingInfo = JSON.stringify(
      this.supportingDocuments,
    );
    this.$modal.show('survey-spinner');
    vxm.jobs.postSupportingInfo(this.supportingInfoPayload).then((response) => {
      this.$modal.hide('survey-spinner');
      this.processJobApplicationResponse(
        response.data,
        parseInt(this.$route.params.JobID, 10),
      );
    });
  }

  get resumeList(): GenericLookup[] {
    const start = this.currentPage * this.recsPerPage - this.recsPerPage;
    const end = this.currentPage * this.recsPerPage - 1;
    return this.genericLookup.filter((s, idx) => {
      return idx >= start && idx <= end;
    });
  }

  selectDefault() {
    this.selectedOption = new GenericLookup();
    this.selectedOption.name = '';
    this.selectProfileResume('');
    this.genericLookup = [];
    if (this.resumeListing.resumes.length === 0) {
      this.$wlToastr(
        'info',
        this.$t('ResumeDetails_NoResumeInProfile'),
        this.$t('MyJobListing_JobApplication'),
      );
      return;
    }
    this.resumeListing.resumes.forEach((r) => {
      if (this.genericLookup.length < this.resumeListing.resumes.length) {
        const gLookup = new GenericLookup();
        gLookup.id = r.fileGUID;
        gLookup.name = r.name;
        gLookup.description = r.reference;
        gLookup.isSelected = r.defaultResume;
        this.genericLookup.push(gLookup);
      }
      this.$modal.show('default-resume');
    });
  }

  private userProfile: UserProfile = new UserProfile();
  private companySkills: SkillResponse[] = [];
  private documentPayload: DocumentPayload = new DocumentPayload();
  private currentPageTop: number = 1;
  private recsPerPageTop: number = 5;
  private selectedIndex: number = -1;
  private selectedSkillId: number = -1;
  private bFormFiles: any[] = [];
  public branchedQuestionnierComplete : boolean = false;
  public tempSkillTypes: SkillDocWrapper[] = [];
  private editSkills: boolean = false;
  private expandAll: boolean = false;
  private searchSkill: string = '';
  private filteredCompanySkills: SkillResponse[] = [];
  private companyVerticalSkills: VerticalSkillRespose[] = [];
  private filteredCompanyVerticalSkills: VerticalSkillRespose[] = [];
  private expandCurrent: boolean = false;
  private displayVerticalArr: String[] = [];
  private selectedUploadSkillAttr: string = '';
  private skillDocumentUploaded: string = '';
  private userAttrSkillWrappers: UserAttrSkillWrapper[] = [];
  private selectedSkills: number[] = [];
  public userFileAttributeDoc: any;
  private startDate: any;
  private skillDocument: SkillDocument = new SkillDocument();
  private skillSearchUploadDocument: SkillDocument = new SkillDocument();
  private replaceSelectedAttributeId: number = -1;
  private selectedSkill: SkillResponse = new SkillResponse();
  private selectedUserAttribute: UserAttribute = new UserAttribute();
  private selectedUserAttrSkillWrapper: UserAttrSkillWrapper = new UserAttrSkillWrapper();
  private documentExpires: boolean = false;
  private skipSkillAttribute: String = '';
  private skipSkillAttributes: String[] = [];
  private documentExpiresEdit: boolean = false;
  private replaceUploadedDocument: boolean = false;
  private replaceUploadedDocumentEdit: boolean = false;
  private effectiveDateStr: string = '';
  private showModal: boolean = false;
  private showModalEdit: boolean = false;
  private isApplyBtnEnabled: boolean = false;
  private bookmarks: any[] = [];
  private selectedDocument: DocumentResponse = new DocumentResponse();
  private documentId: number = 0;
  private documentName: String = 'Uploaded document';
  private skillDocLicenceState: string = '';
  private skillDocLicenceNumber: string = '';

  get sIndex() {
    return this.selectedIndex;
  }

  get pageCount() {
    const skillResponses = vxm.skills.CompanySkillWrapper.skillResponses;
    const pageCount = skillResponses != null ? skillResponses.length : 0;
    return Math.ceil(pageCount / this.recsPerPage);
  }

  get pageCountTop() {
    const skillResponses = this.userProfile.skillTypes;
    const pageCount = skillResponses != null ? skillResponses.length : 0;
    return Math.ceil(pageCount / this.recsPerPage);
  }

  get isShowSpinner() {
    // return vxm.users.isLoadingProfile;
    //return (vxm.utility.spinnerStatus || vxm.users.isLoadingProfile);
    console.log(
      'vxm.utility.spinnerStatus:' +
        vxm.utility.spinnerStatus +
        ' vxm.users.isLoadingProfile:' +
        vxm.users.isLoadingProfile,
    );
    return vxm.users.isLoadingProfile;
  }

  toggleDocumentExpires() {
    this.documentExpires = !this.documentExpires;
  }

  toggleDocumentExpiresEdit() {
    this.documentExpiresEdit = !this.documentExpiresEdit;
  }

  setSelectedUploadSkillAttr(selectedUserAttribute: string) {
    this.selectedUploadSkillAttr = selectedUserAttribute;
  }

  hideUploadSkillAttr(selectedUserAttribute: string) {
    return this.selectedUploadSkillAttr == selectedUserAttribute;
  }

  setSkillDocumentUploaded(selectedUserAttribute: string) {
    this.skillDocumentUploaded = selectedUserAttribute;
  }

  hideSkillDocumentUploaded(selectedUserAttribute: string) {
    return this.skillDocumentUploaded == selectedUserAttribute;
  }

  checkDoc(file: any) {
    setTimeout(() => {
      console.log(this.bFormFiles);
    }, 500);
  }
  getDocumentCount(skillTypeId: number): number {
    const filteredSkillRespList = vxm.skills.CompanySkillWrapper.skillResponses.filter(
      (doc) => {
        return doc.skillTypeId === skillTypeId;
      },
    );
    if (Array.isArray(filteredSkillRespList) && filteredSkillRespList.length) {
      return filteredSkillRespList[0].userAttributes.length;
    }
    return 0;
  }

  getDocuments(skillTypeId: number): UserAttribute[] {
    const documents = vxm.skills.CompanySkillWrapper.skillResponses.filter(
      (doc) => {
        return doc.skillTypeId === skillTypeId;
      },
    )[0].userAttributes;
    return documents;
  }

  getDocumentsFlagged(sdw: SkillDocWrapper): UserAttribute[] {
    const docs = this.getDocuments(sdw.skillType.skillTypeId);
    docs.forEach((doc) => {
      const idx = sdw.documentList.findIndex((rec) => {
        return rec.userAttributeId === doc.userAttributeID;
      });

      if (idx >= 0) {
        doc.isPresent = true;
      } else {
        doc.isPresent = false;
      }
    });
    return docs;
  }
  isVerticalExists(verticalName: String): boolean {
    return this.displayVerticalArr.includes(verticalName.toLowerCase());
  }

  addVertical(verticalName: String) {
    this.displayVerticalArr.push(verticalName.toLowerCase());
  }

  removeVertical(verticalName: String) {
    const filteredVerticals = this.displayVerticalArr.filter((doc) => {
      return doc.toLowerCase() != verticalName.toLowerCase();
    });
    this.displayVerticalArr = filteredVerticals;
  }

  clearDisplayVerticalArr() {
    this.displayVerticalArr = [];
  }

  bookmarkJob(job: any) {
    let jobs = this.bookmarks.filter(
      (bookmark) => bookmark.objectId === job.jobPostingId,
    );
    if (jobs && jobs.length > 0) {
      for (let bookmark of this.bookmarks) {
        if (job.jobPostingId == bookmark.objectId) {
          if (job.bookmarkStatus && job.bookmarkStatus === 'A') {
            job.bookmarkStatus = 'D';
            bookmark.action = 'D';
          } else if (job.bookmarkStatus && job.bookmarkStatus === 'D') {
            job.bookmarkStatus = 'A';
            bookmark.action = 'A';
          }
        }
      }
    } else if (job.bookmarkStatus && job.bookmarkStatus === 'A') {
      job.bookmarkStatus = 'D';
      this.bookmarks.push({
        action: 'D',
        type: '01',
        objectId: job.jobPostingId,
      });
    } else if (job.bookmarkStatus && job.bookmarkStatus === 'D') {
      job.bookmarkStatus = 'A';
      this.bookmarks.push({
        action: 'A',
        type: '01',
        objectId: job.jobPostingId,
      });
    }

    let bookmarkIcon = this.$refs['bookmark_' + job.jobPostingId];
    if (job.bookmarkStatus && job.bookmarkStatus === 'A') {
      bookmarkIcon[0].classList = ['fa fa-bookmark secondary-color bookmark-icon'];
    } else if (job.bookmarkStatus && job.bookmarkStatus === 'D') {
      bookmarkIcon[0].classList = [
        'fa fa-bookmark-o remove-color bookmark-icon',
      ];
    }
    let req = {
      sessionToken: '13223',
      bookmarks: this.bookmarks,
    };
    if (this.bookmarks && this.bookmarks.length > 0) {
      vxm.jobs.bookmarkJob(req).then((resp) => {});
    }
  }

  destroyed() {
    localStorage.nextpage = '';
    this.nextpage = '';
    let req = {
      sessionToken: '13223',
      bookmarks: this.bookmarks,
    };
    if (this.bookmarks && this.bookmarks.length > 0) {
      vxm.jobs.bookmarkJob(req).then((resp) => {});
    }
  }

  addAllVerticals() {
    this.displayVerticalArr = [];
    this.companyVerticalSkills.forEach((value) => {
      this.displayVerticalArr.push(value.verticalName.toLowerCase());
    });
  }

  toggleIndex(idx: number, skillTypeId: number) {
    if (this.selectedIndex === -1) {
      this.selectedIndex = this.getIndex(idx);
    } else {
      this.selectedIndex = -1;
    }
    console.log(this.selectedIndex);
  }

  getIndex(idx: number): number {
    return (
      this.recsPerPageTop * this.currentPageTop - this.recsPerPageTop + idx
    );
  }

  clickCallback(page) {
    this.currentPage = page;
  }

  clickCallbackTop(pageTop) {
    this.currentPageTop = pageTop;
  }

  get skills(): SkillDocWrapper[] {
    if (this.userProfile.skillTypes === null) {
      return [];
    }
    return this.userProfile.skillTypes;
    /*const start = this.currentPageTop * this.recsPerPageTop - this.recsPerPageTop;
    const end = this.currentPageTop * this.recsPerPageTop - 1;
     if(this.userProfile.skillTypes===null){
      return [];
    }
    return this.userProfile.skillTypes.filter((s, idx) => {
      if (this.selectedIndex === -1) {
        return idx >= start && idx <= end;
      } else {
        return idx === this.selectedIndex;
      }
    });*/
  }

  deleteSkill(skillTypeId: number) {
    const vm = this;
    const respPromise: any = vxm.skills.deleteSkillApplyFLow(skillTypeId);
    Promise.all([respPromise]).then((values) => {
      if (!values[0].success) {
        vm.$wlToastr(
          'error',
          vm.$t('unable-to-delete-skill-err-msg'),
          vm.$t('job-apply-text'),
        );
      } else {
        vm.$wlToastr(
          'success',
          vm.$t('skill-deleted-success-msg'),
          vm.$t('job-apply-text'),
        );
      }
    });
  }

  async activateSkill(skill: SkillType) {
    const sdw = new SkillDocWrapper();
    if (!this.skillExist(skill)) {
      sdw.skillType.skillTypeId = skill.skillTypeId;
      sdw.skillType.skillTypeName = skill.skillTypeName;
      console.log('skill.skillTypeDescription:' + skill.skillTypeDescription);
      sdw.skillType.skillTypeDescription = skill.skillTypeDescription;
      sdw.skillType.createdDTTM = new Date(skill.createdDTTM);
      sdw.skillType.updateDTTM = new Date(skill.updateDTTM);
      sdw.skillType.locale = skill.locale;
      sdw.skillType.status = skill.status;
      if (this.userProfile.skillTypes == null) {
        this.tempSkillTypes.push(sdw);
        this.userProfile.skillTypes = this.tempSkillTypes;
      } else {
        this.userProfile.skillTypes.push(sdw);
      }
      const vm = this;
      const respPromise: any = vxm.users.addSkillsToUserProfile(vm.userProfile);
      const resp = await respPromise;
      if (resp.success) {
        await vxm.skills.activateSkill(skill.skillTypeId);
        vm.$wlToastr(
          'success',
          vm.$t('skill.success.message'),
          vm.$t('job-apply-text'),
        );
      } else {
        vm.$wlToastr(
          'error',
          vm.$t('skill-selection-error-message'),
          vm.$t('job-apply-text'),
        );
      }
    } else {
      this.$wlToastr(
        'error',
        this.$t('skill-already-selected-message'),
        this.$t('job-apply-text'),
      );
    }
  }

  skillExist(skill: SkillType): boolean {
    const existingSkillTypes = this.userProfile.skillTypes;
    if (existingSkillTypes != null) {
      return existingSkillTypes.some(
        (existingSkillType) =>
          existingSkillType.skillType.skillTypeId === skill.skillTypeId,
      );
    }
    return false;
  }

  saveUserProfile() {
    vxm.users.saveUserProfile({
      userProfile: this.userProfile,
      isPartofRegistration: false,
    });
  }

  get AvailableSkills(): SkillResponse[] {
    /*const start = this.currentPage * this.recsPerPage - this.recsPerPage;
    const end = this.currentPage * this.recsPerPage - 1;
    return vxm.skills.CompanySkillWrapper.skillResponses.filter((s, idx) => {
      return idx >= start && idx <= end;
    });*/
    return vxm.skills.CompanySkillWrapper.skillResponses;
  }

  saveChanges() {
    console.log(this.userProfile);
    this.saveUserProfile();
  }

  editSavedSkills() {
    this.editSkills = true;
    this.expandAll = false;
    this.skipSkillAttributes = [];
    this.filteredCompanyVerticalSkills =
      vxm.skills.CompanySkillWrapper.verticalSkillResposes;
    this.clearDisplayVerticalArr();
  }

  saveEditedSkills() {
    this.editSkills = false;
  }

  collapseAllMenu() {
    this.expandAll = false;
    this.clearDisplayVerticalArr();
  }

  processResuemUploadAnon(resumePayload: ResumePayload) {
    let completed = false;
    if (!!resumePayload) {
      completed = true;
      this.resumePayload = resumePayload;
      this.isResumeActionComplete = true;
      this.$emit('job-application-step-submission', {
        stepName: 'RESUME',
        data: this.resumePayload,
        completed: completed,
      });
    }
  }

  openAllMenu() {
    this.expandAll = true;
    this.addAllVerticals();
  }

  toggleExpandCurrent() {
    this.expandCurrent = !this.expandCurrent;
  }
  getSeachedSkill(searchVal: string) {
    this.skipSkillAttributes = [];
    if (searchVal == '') this.collapseAllMenu();
    else this.openAllMenu();

    this.filteredCompanyVerticalSkills = [];
    this.companyVerticalSkills.forEach((value) => {
      const filteredSkills = value.skillResponses.filter((doc) => {
        return doc.skillTypeName
          .toLowerCase()
          .startsWith(searchVal.toLowerCase());
      });
      var testObj = new VerticalSkillRespose();
      testObj.skillResponses = filteredSkills;
      testObj.verticalName = value.verticalName;
      this.filteredCompanyVerticalSkills.push(testObj);
    });
  }

  get SearchedSkills(): SkillResponse[] {
    return this.filteredCompanySkills;
  }

  get VerticalSearchedSkills(): VerticalSkillRespose[] {
    return this.filteredCompanyVerticalSkills;
  }

  checkUserAttrDoc(file: any) {
    setTimeout(() => {
      console.log(this.skillDocument.userAttrDoc);
    }, 500);
  }

  checkUserAttrDocEdit(file: any) {
    setTimeout(() => {
      console.log(this.skillSearchUploadDocument.userAttrDoc);
    }, 500);
  }

  /* uploadUserAttribute(uID:number, skillTypes : SkillType[]) {
    const vm =this;
    const file = this.skillDocument.userAttrDoc;//this.userAttrDoc;
    if(!file){
          vm.$wlToastr('error',vm.$t('profile.upload.skill.document.file.required'), 'Upload Document');
      }else{
          this.documentPayload.documentName = file.name;
          this.documentPayload.documentFile = file;
          this.documentPayload.uid = uID;
           skillTypes.forEach( value => {
             this.documentPayload.document.documentName = '{"userAttributeId": ' + uID +',"skillTypeId": ' + value.skillTypeId + '}';
             console.log('UID:'+uID+' skilltypeId:'+value.skillTypeId);
             vxm.skills.uploadSkillDocument(this.documentPayload);
          });
        }
  }*/

  isAttrbiuteUploadedforuserAttrSkillWrapper(
    val: UserAttrSkillWrapper,
  ): boolean {
    if (val == null) return false;
    if (val.documentResponse !== null) return true;
    else return false;
  }

  getUploadedDoc(val: UserAttrSkillWrapper): String {
    const selectedWrapper = this.userProfile.userAttributeSkills.filter(
      (doc) => {
        return (
          doc.userAttribute.userAttributeID == val.userAttribute.userAttributeID
        );
      },
    )[0];
    if (
      selectedWrapper === undefined ||
      selectedWrapper.documentResponse === undefined
    ) {
      return '';
    } else {
      if (selectedWrapper.documentResponse !== null)
        return selectedWrapper.documentResponse.docGUID;
      else return '';
    }
  }

  ShowSkillDoc(fulldocPath: string) {
    const docLink =
      vxm.configs.getGlobalConfigValue('CANDIDATE_PORTAL_CONTEXT_URL') +
      fulldocPath;
    console.log('docLink', docLink);
    window.open(docLink);
  }

  isUserAttributeUploadedForSkill(
    skillTypeId: number,
    userAttributeID: number,
  ): boolean {
    if (skillTypeId && userAttributeID) {
      const docArray = this.getUploadedDocumentList(
        skillTypeId,
        userAttributeID,
      );
      if (docArray !== null && docArray.length > 0) {
        // console.log('skillTypeId:'+skillTypeId+' userAttributeId:'+userAttributeID+'docArray:'+docArray+' returning true');
        return true;
      }
    }
    return false;
  }

  getUploadedDocumentList(
    skillTypeId: number,
    userAttributeID: number,
  ): DocumentResponse[] {
    const existingSkillTypes = this.userProfile.skillTypes.filter((doc) => {
      return doc.skillType.skillTypeId == skillTypeId;
    });
    const existingSkillType = existingSkillTypes[0];
    if (null == existingSkillType.documentList) {
      return new DocumentResponse[0]();
    }
    const docList = existingSkillType.documentList.filter((doc) => {
      return doc.userAttributeId == userAttributeID;
    });
    return docList;
  }

  getUploadedDocument(
    skillTypeId: number,
    userAttributeID: number,
  ): DocumentResponse {
    const docArray = this.getUploadedDocumentList(skillTypeId, userAttributeID);
    if (docArray != null && docArray.length > 0) return docArray[0];
    else return new DocumentResponse();
  }

  get getCompanyDateFormat() {
    return vxm.jobs.getCompanyDateFormat || '';
  }

  placeHolderContent(question){
    if(question.questionRequired && question.questionType === '13'){
      return 'please select date *';
    }
    else if(!question.questionRequired && question.questionType === '13'){
      return 'please select date';
    }
    else if(question.questionRequired){
      return 'please select values *';
    }
    else{
    return 'please select values';
    }
  }

  checkUserAttrDocForSkill(file: any) {
    setTimeout(() => {
      console.log(this.skillSearchUploadDocument.userAttrDoc);
    }, 500);
  }

  showReplaceSelectedAttribute(val: number): boolean {
    if (this.replaceSelectedAttributeId == val) {
      return true;
    } else {
      return false;
    }
  }
  replaceSelectedDoc(val: number) {
    this.replaceSelectedAttributeId = val;
  }

  showDocumentsPopUp(val: SkillResponse, userAttribute: UserAttribute) {
    this.selectedSkill = val;
    this.selectedUserAttribute = userAttribute;
    this.replaceUploadedDocumentEdit = false;
    this.skillDocument = new SkillDocument();
    this.showModalEdit = true;
  }

  selectUserAttrSkilllWrapper(val: UserAttrSkillWrapper) {
    this.selectedUserAttrSkillWrapper = val;
    this.skillDocument = new SkillDocument();
    this.showModal = true;
  }

  editJobApplyFlowDocument(
    val: UserAttrSkillWrapper,
    doc: DocumentResponse,
    effectiveDTTM: Date,
    expiryDTTM: Date,
    name: String,
    licenseNumber: string,
    licenseState: string,
  ) {
    this.selectedUserAttrSkillWrapper = val;
    this.skillDocument = new SkillDocument();
    this.showModal = true;
    this.selectedDocument = doc;
    this.documentId = doc.documentId;
    this.documentName = name;
    this.skillDocLicenceState = licenseState;
    this.skillDocLicenceNumber = licenseNumber;

    // this.uploadDocument = true;
    // this.editMode = true;
    if (effectiveDTTM !== null) {
      this.skillDocument.effetiveDTTM = new Date(effectiveDTTM).getTime();
      this.skillDocument.effectiveDTTMText = this.$moment(effectiveDTTM).format(
        'YYYY-MM-DD',
      );
    }
    if (expiryDTTM !== null) {
      this.skillDocument.expiryDTTM = new Date(expiryDTTM).getTime();
      this.skillDocument.expiryDTTMText = this.$moment(expiryDTTM).format(
        'YYYY-MM-DD',
      );
    }
    if (expiryDTTM == null) {
      this.documentExpires = true;
    }
  }

  async downloadResume(fileGUID, name) {
    try {
      const authToken = vxm.users.getToken;
      const url = '/wl-profile-svc/api/v2/user-profile/view/resume/' + fileGUID;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${authToken}`, 
        },
      });
      
      if (!response.ok) {
        throw new Error('Failed to download resume');
      }
      
      const blob = await response.blob();
      
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl; 
      link.download = name || 'Resume';
      
      // Trigger a click event to initiate the download
      link.click();
      
      // Clean up the URL object after download
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Error downloading resume:', error);
    }
  }

  editUserAttrSkilllWrapper(val: UserAttrSkillWrapper) {
    this.replaceUploadedDocument = false;
    this.selectedUserAttrSkillWrapper = val;
    if (val && val.documentResponse) {
      this.skillDocument.effetiveDTTM = val.documentResponse.effectiveDTTM
        ? new Date(val.documentResponse.effectiveDTTM).getTime()
        : val.documentResponse.effectiveDTTM;
      this.skillDocument.effectiveDTTMText = val.documentResponse.effectiveDTTM
        ? new Date(val.documentResponse.effectiveDTTM)
            .toISOString()
            .split('T')[0]
        : val.documentResponse.effectiveDTTM;

      this.skillDocument.expiryDTTM = val.documentResponse.expiryDTTM
        ? new Date(val.documentResponse.expiryDTTM).getTime()
        : val.documentResponse.expiryDTTM;
      this.skillDocument.expiryDTTMText = val.documentResponse.expiryDTTM
        ? new Date(val.documentResponse.expiryDTTM).toISOString().split('T')[0]
        : val.documentResponse.expiryDTTM;
    }
    this.showModal = true;
  }

  setSkipSkillAttribute(skillAttribute: String) {
    this.skipSkillAttributes.push(skillAttribute);
  }

  hideSkillAttribute(skillAttribute: String): boolean {
    return this.skipSkillAttributes.includes(skillAttribute);
  }

  updateSupportingInfo() {
    this.getSupportingInfo().then((response) => {
      setTimeout(() => {
        this.processSupportingInfosResponse(response);
      }, 1000);
    });
  }

  async deleteSkillAttribute(skillAttribute: number, index: number) {
    const vm = this;
    const respPromise: any = vxm.skills.deleteSkillAttributeApplyFlow(
      skillAttribute,
    );
    const resp = await respPromise;
    if (resp.success) {
      vxm.users.removeUserAttributeDoc(skillAttribute);
      this.updateSupportingInfo();
      this.showModal = false;
      vm.$wlToastr('success', resp.successMessage, vm.$t('job-apply-text'));
    } else {
      vm.$wlToastr('error', resp.errorMessage, vm.$t('job-apply-text'));
    }
  }

  transformDate(dttm: number): string {
    console.log('dttm:' + dttm);
    if (dttm === null) return '';
    return new Date(dttm).toLocaleString().split(',')[0];
  }

  saveSkillDetailsMain() {
    console.log(
      'effective date:' +
        this.skillDocument.effectiveDTTMText +
        ' expiry date:' +
        this.skillDocument.expiryDTTMText,
    );

    const skillTypes = this.selectedUserAttrSkillWrapper.skillTypeList;
    const uID = this.selectedUserAttrSkillWrapper.userAttribute.userAttributeID;

    const vm = this;
    const file = this.skillDocument.userAttrDoc; //this.userAttrDoc;
    const allowedResumeFormat = vxm.configs.getGlobalConfigValue(
      'ALLOWED_RESUME_FORMATS',
    );
    if (
      !this.isAttrbiuteUploadedforuserAttrSkillWrapper(
        this.selectedUserAttrSkillWrapper,
      )
    ) {
      if (!file) {
        this.$wlToastr('error', this.$t('select-file-err-msg'), this.$t('job-apply-text'));
        return;
      }
    }
    if (file.size > this.supportedFileSize) {
      this.$wlToastr(
        'error',
        this.$t('License_FileSizeRestriction', {
          maxSize: this.supportedFileSize / (1024 * 1024),
        }),
        this.$t('skill.success.message.title'),
      );
      return;
    }
    // if (!this.skillDocTypeMatches()) {
    //   this.$wlToastr(
    //     'error',
    //     'File type not supported. Upload ' + allowedResumeFormat,
    //     'Skills',
    //   );
    //   return;
    // }
    if (
      this.skillDocument.expiryDTTMText &&
      this.documentExpires &&
      this.skillDocument.effectiveDTTMText === undefined
    ) {
      this.$wlToastr(
        'error',
        this.$t('License_EnterEffectiveDate'),
        this.$t('job-apply-text'),
      );
      return;
    }

    this.skillDocument.effetiveDTTM = this.$moment(
      this.skillDocument.effectiveDTTMText,
    )
      .startOf('day')
      ._d.getTime();
    this.skillDocument.expiryDTTM = this.$moment(
      this.skillDocument.expiryDTTMText,
    )
      .startOf('day')
      ._d.getTime();

    console.log(
      'this.skillDocument.startDTTMText:' +
        this.skillDocument.effectiveDTTMText,
    );
    console.log(
      'this.skillDocument.startDTTM:' + this.skillDocument.effetiveDTTM,
    );
    console.log(
      'this.skillDocument.endDTTMText:' + this.skillDocument.expiryDTTMText,
    );
    console.log(
      'this.skillDocument.expiryDTTM:' + this.skillDocument.expiryDTTM,
    );

    if (!this.documentExpires) {
      if (this.skillDocument.effetiveDTTM >= this.skillDocument.expiryDTTM) {
        this.$wlToastr(
          'error',
          this.$t('document-expire-err-msg'),
          this.$t('job-apply-text'),
        );
        return;
      }
    }

    this.effectiveDateStr = this.skillDocument.effectiveDTTMText;
    this.documentPayload.licenseState = this.skillDocLicenceState;
    this.documentPayload.licenseNumber = this.skillDocLicenceNumber;
    if (file !== undefined && file !== null) {
      this.documentPayload.effectiveDate = this.skillDocument.effetiveDTTM.toString();
      this.documentPayload.expiryDate = this.documentExpires
        ? 'null'
        : this.skillDocument.expiryDTTM.toString();
      this.documentPayload.documentName = file.name;
      this.documentPayload.documentFile = file;
      this.documentPayload.uid = uID;
      this.documentPayload.document.documentName =
        '{"userAttributeId": ' + uID + ',"skillTypeId": ' + uID + '}';
      this.documentPayload.documentId = this.documentId;
    } else {
      this.documentPayload.effectiveDate = this.skillDocument.effetiveDTTM.toString();
      this.documentPayload.expiryDate = this.documentExpires
        ? 'null'
        : this.skillDocument.expiryDTTM.toString();
      this.documentPayload.uid = uID;
      this.documentPayload.document.documentName =
        '{"userAttributeId": ' + uID + ',"skillTypeId": ' + uID + '}';
      this.documentPayload.documentId = this.documentId;
    }
    vxm.skills.uploadApplyFowDocument(this.documentPayload).then((resp) => {
      this.updateSupportingInfo();
      vm.$wlToastr(
        'success',
        vm.$t('document-saved-success-msg'),
        vm.$t('job-apply-text'),
      );
    });
    this.showModal = false;
    this.skillDocument = new SkillDocument();
  }

  saveSkillDetailsEdit(skillTypeId: number, userAttributeID: number) {
    const skillWrapperArr = this.userAttrSkillWrappers.filter((doc) => {
      return doc.userAttribute.userAttributeID == userAttributeID;
    });

    const vm = this;
    const file = this.skillSearchUploadDocument.userAttrDoc;
    const allowedResumeFormat = vxm.configs.getGlobalConfigValue(
      'ALLOWED_RESUME_FORMATS',
    );

    if (!this.isUserAttributeUploadedForSkill(skillTypeId, userAttributeID)) {
      if (!file) {
        this.$wlToastr('error', this.$t('select-file-err-msg'), this.$t('job-apply-text'));
        return;
      }
    }
    if (file.size > this.supportedFileSize) {
      this.$wlToastr(
        'error',
        this.$t('License_FileSizeRestriction', { maxSize: this.supportedFileSize / (1024 * 1024) }),
        this.$t('skill.success.message.title'),
      );
      return;
    }
    // if (!this.skillDocTypeMatches()) {
    //   this.$wlToastr(
    //     'error',
    //     'File type not supported. Upload ' + allowedResumeFormat,
    //     'Skills',
    //   );
    //   return;
    // }
    if (
      this.skillDocument.expiryDTTMText &&
      this.documentExpires &&
      this.skillDocument.effectiveDTTMText === undefined
    ) {
      this.$wlToastr(
        'error',
        this.$t('License_EnterEffectiveDate'),
        this.$t('job-apply-text'),
      );
      return;
    }

    this.skillDocument.effetiveDTTM = this.$moment(
      this.skillDocument.effectiveDTTMText,
    )
      .startOf('day')
      ._d.getTime();
    this.skillDocument.expiryDTTM = this.$moment(
      this.skillDocument.expiryDTTMText,
    )
      .startOf('day')
      ._d.getTime();

    console.log(
      'this.skillDocument.startDTTMText:' +
        this.skillDocument.effectiveDTTMText,
    );
    console.log(
      'this.skillDocument.startDTTM:' + this.skillDocument.effetiveDTTM,
    );
    console.log(
      'this.skillDocument.endDTTMText:' + this.skillDocument.expiryDTTMText,
    );
    console.log(
      'this.skillDocument.expiryDTTM:' + this.skillDocument.expiryDTTM,
    );

    if (!this.documentExpiresEdit) {
      if (this.skillDocument.effetiveDTTM >= this.skillDocument.expiryDTTM) {
        this.$wlToastr(
          'error',
          this.$t('document-expire-err-msg'),
          this.$t('job-apply-text'),
        );
        return;
      }
    }
    if (file !== undefined && file !== null) {
      this.documentPayload.documentName = file.name;
      this.documentPayload.documentFile = file;
      this.documentPayload.uid = userAttributeID;
      this.documentPayload.effectiveDate = this.skillDocument.effetiveDTTM.toString();
      this.documentPayload.expiryDate = this.documentExpires
        ? 'null'
        : this.skillDocument.expiryDTTM.toString();
      this.documentPayload.documentId = this.documentId;

      skillWrapperArr[0].skillTypeList.forEach((value) => {
        this.documentPayload.document.documentName =
          '{"userAttributeId": ' +
          userAttributeID +
          ',"skillTypeId": ' +
          value.skillTypeId +
          '}';
        console.log(
          'UID:' + userAttributeID + ' skilltypeId:' + value.skillTypeId,
        );
        vxm.skills.uploadSkillDocument(this.documentPayload);
      });
    } else {
      this.documentPayload.effectiveDate = this.skillDocument.effetiveDTTM.toString();
      this.documentPayload.expiryDate = this.documentExpires
        ? 'null'
        : this.skillDocument.expiryDTTM.toString();
      this.documentPayload.uid = userAttributeID;
      this.documentPayload.documentId = this.documentId;
      skillWrapperArr[0].skillTypeList.forEach((value) => {
        this.documentPayload.document.documentName =
          '{"userAttributeId": ' +
          userAttributeID +
          ',"skillTypeId": ' +
          value.skillTypeId +
          '}';
        vxm.skills.uploadSkillDocument(this.documentPayload);
      });
      this.skillDocument = new SkillDocument();
    }
    this.showModalEdit = false;
    vm.$wlToastr(
      'success',
      vm.$t('document-saved-success-msg'),
      vm.$t('job-apply-text'),
    );
    //  $('#skillSearchModalScrollable').modal('hide');
  }

  replaceUploadedDoc() {
    this.replaceUploadedDocument = !this.replaceUploadedDocument;
  }

  cancelSaveSkillMain() {
    this.replaceUploadedDocument = false;
    this.showModal = false;
  }

  replaceUploadedDocEdit() {
    this.replaceUploadedDocumentEdit = !this.replaceUploadedDocumentEdit;
  }

  cancelSaveSkillEdit() {
    this.replaceUploadedDocumentEdit = false;
    this.showModalEdit = false;
  }

  closeWindow() {
    this.selectedOption = new GenericLookup();
    this.selectedOption.name = '';
    this.genericLookup = [];
    this.$modal.hide('default-resume');
  }

  closeAndKeep() {
    this.$modal.hide('default-resume');
  }

  getPreviousQuestions(){
    this.getAnonBranchedQuestions("previous")
  }

//  isAllRequiredQuestionAnswered() {
//     let isQuestionAnswered: boolean = true;
//     console.log("answered questions,,,",this.answeredQuestions);
//     for (let question of this.answeredQuestions) {
//       if (
//         (question.questionType === SURVEY_QUESTION_CODE_TEXT ||
//           question.questionType === SURVEY_FEEDBACK_QUESTION_CODE_TEXT) &&
//         this.$refs['question_span1' + question.questionID] &&
//         question.minLength &&
//         question.userQuestionResponse.questionTextResponse.length > 0 &&
//         question.minLength >
//           question.userQuestionResponse.questionTextResponse.length
//       ) {
//         this.$refs['question_span1' + question.questionID][0].focus();
//         this.$refs[
//           'question_span1' + question.questionID
//         ][0].previousSibling.style['border-color'] = 'red';
//         this.$refs['question_span1' + question.questionID][0].style.color =
//           'red';
//         isQuestionAnswered = false;
//       }
//     }
//     return (
//       isQuestionAnswered &&
//       this.answeredQuestions.filter((question) => question.questionRequired)
//         .length === this.requiredQuestionCount
//     );
//   }
get isQuestionnaireCompleted(){
  return   this.branchedQuestionnierComplete
}
  get enableNextBtn(){
    console.log("enable,nect buttom method",this.branchedQuestionnierComplete);
    if(this.hasNextSetOfQuestion && this.branchedQuestionnierComplete){
      return true;
    }
     // this.branchedQuestionnierComplete = false;
    return false;
  }

  async getNextQuestions(){
  if(this.validateOAuthRegistrationData(this.userDetails)){
      const formData = new FormData();
      this.userDetails.userName = this.userDetails.email;
      this.userDetails.companyCode = vxm.users.getCompanyCode;
      this.userDetails.referralCode =  vxm.referrals.globalRefCode ? vxm.referrals.globalRefCode : '';
      formData.append('user', JSON.stringify(this.userDetails));
      if(this.userId == null || this.userId == 0){
         if (vxm.utmtracker.utmTrackerId > 0) {
            formData.append('utmTrackerId', String(vxm.utmtracker.utmTrackerId));
         }
         let  userRegistered  =   await vxm.jobs.quickAnonRegister(formData);
         if ( userRegistered && userRegistered.data &&
           userRegistered.data.success && userRegistered.data.userId){
             this.userId = userRegistered.data.userId;
             this.$emit('anon-user-create',this.userId);
           if(this.userId != null || this.userId !=0){
             if(!this.validateUserQuestionResponse){
              this.$wlToastr(
                'error',
                'Please enter mandatory fields.',
                'Job Application',
               );
             }else{
              this.getAnonBranchedQuestions("next")
             }
           }   
          }else {
        this.$wlToastr('error', userRegistered.data.errorMessage, 'Upload Resume');
        return;
        }
      }else{
        if(!this.validateUserQuestionResponse){
              this.$wlToastr(
                'error',
                'Please enter mandatory fields.',
                'Job Application',
               );
             }else{
              this.getAnonBranchedQuestions("next") 
             }
      }
   }
    
  }
  validateOAuthRegistrationData(user: User): boolean {
    console.log("validatingh........")
    let isValid: boolean = true;
    this.errors = {
      email: '',
      password: '',
      confirmPassword: '',
      firstName: '',
      lastName: '',
      phone: '',
    };
    const emailformat = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (!user.firstName) {
      this.errors.firstName = 'signup.firstname.required';
    }
    if (!user.lastName) {
      this.errors.lastName = 'signup.lastname.required';
    }
    if (!user.email.match(emailformat)) {
      this.errors.email = 'signup.enter.valid.email';
    }
    if (!user.email) {
      this.errors.email = 'signup.email.required';
    }
    if (!user.phoneNumberValid) {
      this.errors.phone = 'signup.phone.valid';
    }
    if (!user.phone) {
      this.errors.phone = 'signup.phone.required';
    }
    Object.keys(this.errors).forEach((key) => {
      isValid = isValid && !this.errors[key];
    });
    this.$emit('user-errors',this.errors);
    console.log("errros",this.errors);
    return isValid;
  }
  
  getQuestionnaire() {
    const jobId = this.$route.params.JobID;
    const jtp = new JobTokenPayload();
    jtp.token = vxm.users.getToken;
    jtp.jobID = parseInt(jobId, 10);
    vxm.jobs.getQuetionaireListing(jtp);
  }

  getSupportingInfo() {
    const jobId = this.$route.params.JobID;
    const jtp = new JobTokenPayload();
    jtp.token = vxm.users.getToken;
    jtp.jobID = parseInt(jobId, 10);
    return vxm.jobs.getSupportingInfo(jtp);
  }

  uploadResume() {
    const vm = this;
    const token = vxm.users.getToken;
    vm.resumePayload.accessToken = token;
    vm.resumePayload.jobpostingid = parseInt(this.$route.params.JobID, 10);
    vm.resumePayload.resumelink = '';
    console.log(this.resumePayload);
    if (this.resumePayload.resume.resumename.length > 250) {
      this.$wlToastr(
        'error',
        this.$t('profile.resume.file.name.exceeded'),
        this.$t('MyJobListing_JobApplication'),
      );
      return;
    }
    const respPromise: any = vxm.jobs.postResume(this.resumePayload);
    Promise.all([respPromise]).then((values) => {
      console.log(values[0]);
      if (values[0]) {
        if (values[0].success) {
          vxm.jobs.getDefaultResume(vxm.users.getToken).then(() => {
            vm.resumeListing = vxm.jobs.resumeListing;
            vm.selectedOption.name = '';
            vm.resumePayload.resumefile = '';
            vm.selectProfileResume(this.resumePayload.resume.resumename);
            vm.uploadedResumeGUID = values[0].resumeGUID;
            this.enableResumeUploadBtn = false;
            this.isResumeActionComplete = true;
            vm.$wlToastr(
              'info',
              vm.$t('profile.upload.resume.sucess'),
              vm.$t('MyJobListing_JobApplication'),
            );
          });
        } else {
          vm.$wlToastr(
            'error',
            vm.$t('profile.upload.resume.error'),
            vm.$t('MyJobListing_JobApplication'),
          );
        }
      }
    });
  }

  setName() {
    setTimeout(() => {
      if (this.resumePayload.resumefile.name) {
        this.selectedOption = new GenericLookup();
        this.selectedOption.name = '';
        this.selectProfileResume('');
        this.genericLookup = [];
        this.resumePayload.resume.resumename = this.resumePayload.resumefile.name;
      }
    }, 50);
  }

  JobID() {
    return parseInt(this.$route.params.JobID, 10);
  }

  toggleReferrals() {
    this.showDetail = !this.showDetail;
  }

  getToggleValue() {
    return this.showDetail;
  }

  truncate(str: string, len: number, suffix: string) {
    if (str.length > len) {
      return str.substring(0, len) + suffix;
    } else {
      return str;
    }
  }

  renderDate(xDate: Date): string {
    if (vxm.jobs.getCompanyDateFormat) {
      return (
        'STARTING: ' +
        this.$moment(xDate).format(vxm.jobs.getCompanyDateFormat.toUpperCase())
      );
    }
    return 'STARTING: ' + this.$moment(xDate).format('DD-MMM-YYYY');
  }

  validateFileFormate() {
    const vm = this;
    vm.selectedResume = '';
    setTimeout(() => vm.validationFileFormatResume(), 50);
  }

  validationFileFormatResume() {
    const vm = this;
    console.log([vm.resumePayload]);
    this.resumePayload.resume.resumename = vm.resumePayload.resumefile.name;
    const ext = vm.resumePayload.resumefile.name.match(/\.([^\.]+)$/)[1];
    const fileNameFormat = vm.resumePayload.resumefile.name.match(
      /\.([^\.]+)$/,
    )[0];
    const allowedResumeFormat = vxm.configs.getGlobalConfigValue(
      'ALLOWED_RESUME_FORMATS',
    );
    if (!allowedResumeFormat.includes(ext)) {
      this.$wlToastr(
        'error',
        fileNameFormat +
          ` is an unsupported file format. Following file formats are allowed: ${allowedResumeFormat}`,
        this.$t('ResumeDetails_UploadResume'),
      );

      vm.resumePayload.resumefile = '';
    }
  }

  saveQuestionnaireData() {
    if (!this.validateUserQuestionResponse()) {
      this.$wlToastr(
        'error',
        'Please enter mandatory fields.',
        this.$t('MyJobListing_JobApplication'),
      );
    } else {
      const vm = this;
      const jobId = this.$route.params.JobID;
      const jtp = new JobTokenPayload();
      jtp.token = vxm.users.getToken;
      jtp.jobID = parseInt(jobId, 10);
      const questionnaireResponse = new QuestionnaireResponse();
      questionnaireResponse.userId = vxm.users.myUserProfile.userId + '';
      questionnaireResponse.referralCode = vxm.referrals.globalRefCode
        ? vxm.referrals.globalRefCode
        : '';
      questionnaireResponse.jobPostingId = jobId;
      questionnaireResponse.questionResponseData = this.prepareQuestionnaireRequestPayload();
      vxm.jobs.setQAResponse(questionnaireResponse);
      const respPromise: any = vxm.jobs.saveQuestionnaire(jtp);
      this.$modal.show('survey-spinner');
      Promise.all([respPromise]).then((values) => {
        this.$modal.hide('survey-spinner');
        if (values[0]) {
          if (values[0].success) {
            const successMessage = this.$t('jobs.successfully.applied');
            vm.$wlToastr(
              'success',
              successMessage,
              vm.$t('MyJobListing_JobApplication'),
            );
            this.$router.push({
              name: 'JobApplicationSuccess',
              params: { jobId },
            });
          }
          if (!values[0].success) {
            const errorMessageText =
              values[0].errorMessage !== ''
                ? values[0].errorMessage
                : 'Failure while Saving Questions';
            vm.$wlToastr(
              'error',
              errorMessageText,
              vm.$t('MyJobListing_JobApplication'),
            );
          }
        }
      });
    }
  }

  validateUserQuestionResponse(): boolean {
    let result = true;
    const questionRequiredMap = new Map();
    if(this.hasBranchedQuestionere){
      this.questionnaireData = this.branchedQuestions;
    }
    console.log("this.questionnaireData",this.questionnaireData ,"... and ...branched question",this.branchedQuestions);
    this.questionnaireData.forEach((element) => {
      if (element.questionRequired) {
        questionRequiredMap.set(element.questionID, element.questionType);
      }
    });
    this.questionnaireData.forEach((element) => {
      if (questionRequiredMap.has(parseInt(element.questionID, 10))) {
        console.log([questionRequiredMap]);
        const questionType = questionRequiredMap.get(
          parseInt(element.questionID, 10),
        );

        if (questionType === '01') {
          // Multiple Type Question
          for (
            let i = 0, l = element.userQuestionResponse.userAnswerList.length;
            i < l;
            i++
          ) {
            if (element.userQuestionResponse.userAnswerList[i]) {
              result = true;
              break;
            } else {
              result = false;
            }
          }
        } else if (questionType === '02') {
          // Paragraph Question
          if (!element.userQuestionResponse.questionTextResponse) {
            result = false;
          }
        } else if (questionType === '03') {
          // Radio Question
          for (
            let i = 0, l = element.userQuestionResponse.userAnswerList.length;
            i < l;
            i++
          ) {
            if (element.userQuestionResponse.userAnswerList[i]) {
              result = true;
              break;
            } else {
              result = false;
            }
          }
        } else if (questionType === '04') {
          // short text
          if (!element.userQuestionResponse.questionTextResponse) {
            result = false;
          }
        }
      }
    });
    console.log('validation result', result);
    return result;
  }

  getCompanyLogoUrl(companyCode: string): string {
    return vxm.jobs.getCompanyLogoUrl(companyCode);
  }
  isDateInPast(dttm: number): boolean {
    if (dttm === null) return false;
    var result = new Date(dttm);
    result.setDate(result.getDate() + 1);
    dttm = result.getTime();
    var expDate = new Date(dttm);

    var now = new Date();
    if (now > expDate) return true;
    else return false;
  }

  getFristCapitalletter(value: string): string {
    if (!value) return '';
    value = value.toString();
    return value
      .trim()
      .charAt(0)
      .toUpperCase();
  }
  skillDocTypeMatches(): boolean {
    const ext = this.skillDocument.userAttrDoc.name.match(/\.([^\.]+)$/)[1];
    const allowedResumeFormat = vxm.configs.getGlobalConfigValue(
      'ALLOWED_RESUME_FORMATS',
    );
    console.log('ext::' + ext);
    console.log('allowedResumeFormat::' + allowedResumeFormat);
    return allowedResumeFormat.includes(ext);
  }
}
